export default __webpack_public_path__ + "static/media/on-it.8c29189d.gif";